module.exports = __webpack_public_path__ + "static/media/government-logo.4c1079ad.png";


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/assets/images/government-logo.png
// module id = ../lib/egov-ui-kit/assets/images/government-logo.png
// module chunks = 504